import { CircularProgress } from "@mui/material";

const LoadingSpinner = ({ size = 30, color = "#eecb3d" }) => {
  return (
    <CircularProgress
      size={size}
      sx={{
        color: color,
      }}
    />
  );
};

export default LoadingSpinner;
